import { useProfile } from '../../stores/profile-store';
import { useAuth } from '../../stores/auth-store';

export default async function fetchProfile() {
    const profile = useProfile();
    const auth = useAuth();

    if (profile.profileFetched) return;

    if (auth.isLoggedIn) {
        await profile.getProfile();
    }
}
